import React, { Fragment } from 'react'
import LogChart from '@modul-connect/shared/components/organisms/logChart'
import KpiRow from '@modul-connect/shared/components/molecules/kpiRow/kpiRow'
import { ticks_24_hours, ticks_7_days } from './ticks'
import theme from '@modul-connect/shared/theme'
import { getBatteryWarningColor } from '../../../../../utils/vehicleUtils'
import { getTicks } from './logGraphs'
import { useTranslation } from 'react-i18next'

const LpsLogGraph = ({
  vehicle,
  logs,
  log_loading,
  onBatteryIntervalChanged,
  intervals,
  batteryLogInterval,
  oldPicker,
  setStartTime,
  setEndTime,
  startTime,
  endTime
}) => {

  const defaultBatteryGuard = 50

  const {t} = useTranslation()
  
  const lps = vehicle?.currentStatus?.lithiumPowerSupply
  const kpiData_battery = lps ? 
    [{
      title: t('vehicleDetails.currentPercentage') ,
      value: (lps?.batteryPercentage || lps?.batteryPercentage === 0) ? lps?.batteryPercentage : '-',
      unit: '%',
      color: (!lps?.batteryPercentage && lps?.batteryPercentage !== 0) ? theme.colors.text : getBatteryWarningColor(lps.batteryPercentage, defaultBatteryGuard)
    }] : {} 

  return (
    <Fragment>
      {
        (vehicle?.currentStatus?.batteries?.length || log_loading.fetchBatteryLogs !== 'loading') &&
        <KpiRow title={'Status'} width={'100%'} data={kpiData_battery} />
      }
      {
        <LogChart
          oldPicker={false}
          setStartTime={setStartTime}
          setEndTime={setEndTime}
          startTime={startTime}
          endTime={endTime}
          data={logs ? logs.map(log => {
            return { 
              boxId: log.boxId,
              id: log.boxId,
              telematicsId: log.telematicsId,
              timestamp: log.timestamp,
              percentage: log.batteryPercentage,
            }}) : []}
          data_key="percentage"
          data_name={t('vehicleDetails.lps.charge')}
          //max_name="Min. Lps Percentage"
          title={t('vehicleDetails.lpsPercentage')}
          unit="%"
          line_type={'stepAfter'}
          domain={[
            0,
            100
          ]}
          displayTimeInHours={true}
          ticks={getTicks(null, true, startTime, endTime)}
        />
      }
    </Fragment>
  )
}

export default LpsLogGraph


